import { render } from "./PrintPhoto.vue?vue&type=template&id=0bce785a&scoped=true"
import script from "./PrintPhoto.vue?vue&type=script&lang=js"
export * from "./PrintPhoto.vue?vue&type=script&lang=js"

import "./PrintPhoto.vue?vue&type=style&index=0&id=0bce785a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bce785a"]])

export default __exports__